const translations = {
  'Channels': {
    en: 'Channels',
    es: 'Canales',
    pt: 'Canais',
  },
  'Events': {
    en: 'Events',
    es: 'Eventos',
    pt: 'Eventos',
  },
  'There is currently no content available': {
    en: 'There is currently no content available',
    es: 'No hay contenido disponible actualmente',
    pt: 'Não há conteúdo disponível atualmente',
  },
}

export default translations